{
    "raporgunlukisler": {
        "Baslik": "Daily Tasks Report",
        "Tarih": "Date",
        "Kullanici": "User",
        "Aciklama": "File / Process Description",
        "Saat": "Time",
        "Arama": "Search",
        "Ara": "Search",
        "Kapat": "Close",
        "Temizle": "Clear",
        "BaslangicTarihi": "Start Date",
        "BitisTarihi": "End Date",
        "BaslamaSaat": "Start Time",
        "BitisSaat": "End Time",
        "Islemler": "Actions",
        "Duzenle": "Edit",
        "Sil": "Delete",
        "Guncelle": "Update",
        "EminMisiniz": "Are you sure?",
        "GeriAlamazsiniz": "You won't be able to revert this!",
        "EvetSil": "Yes, delete it!",
        "Iptal": "Cancel",
        "GoruntuleTooltip": "View",
        "SilTooltip": "Delete",
        "Kapsam": "Scope",
        "Takim": "Team",
        "Sube": "Branch",
        "Kendi": "Own",
        "Tam": "Full"
    }
}
